module.exports = __webpack_public_path__ + "img/group-4371.ac5f31f4.svg";